import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './RichTextEditor.css';

function RichTextEditor({ 
    label, 
    fieldName, 
    value, 
    onChange, 
    placeholder = "Enter your text...",
    height = "120px",
    // ✅ NEUE FONT-PROPS für dynamische Styling
    fontFamily = null,
    fontSize = null,
    fontWeight = null,
    textColor = null
}) {
    const [editorValue, setEditorValue] = useState(value || '');

    useEffect(() => {
        setEditorValue(value || '');
    }, [value]);

    const handleChange = (content) => {
        setEditorValue(content);
        
        // Validierung: fieldName darf nicht undefined sein
        if (!fieldName) {
            console.error('⚠️ RichTextEditor: fieldName is required but undefined!');
            return;
        }
        
        // Erstelle ein Event-ähnliches Objekt für Kompatibilität
        const fakeEvent = {
            target: {
                name: fieldName,
                value: content,
                type: 'text'
            }
        };
        
        if (onChange) {
            onChange(fakeEvent);
        }
    };

    // Minimale Toolbar für einfache Formatierung
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
        ]
    };

    const formats = [
        'bold', 'italic', 'underline',
        'color', 'background'
    ];

    // ✅ DYNAMISCHE FONT-STYLES für Editor
    const editorStyle = {
        height: height,
        marginBottom: '42px', // Platz für Toolbar
        ...(fontFamily && { fontFamily: fontFamily }),
        ...(fontSize && { fontSize: fontSize }),
        ...(fontWeight && { fontWeight: fontWeight }),
        ...(textColor && { color: textColor })
    };

    return (
        <div className="rich-text-editor-container">
            <label className="rich-text-editor-label">{label}</label>
            <div 
                className="rich-text-editor-wrapper"
                style={{
                    // ✅ CSS CUSTOM PROPERTIES für Quill-Editor
                    '--editor-font-family': fontFamily || 'inherit',
                    '--editor-font-size': fontSize || 'inherit',
                    '--editor-font-weight': fontWeight || 'inherit',
                    '--editor-text-color': textColor || 'inherit'
                }}
            >
                <ReactQuill
                    value={editorValue}
                    onChange={handleChange}
                    modules={modules}
                    formats={formats}
                    placeholder={placeholder}
                    style={editorStyle}
                    theme="snow"
                />
            </div>
        </div>
    );
}

export default RichTextEditor;
